(function($, undefined)
{
    "use strict";

    Date.prototype.addHours = function(h)
    {
        this.setHours(this.getHours()+h);
        return this;
    }

    var hasLocalStorage = function()
    {
        var mod = 'modernizr';
        try {
            localStorage.setItem(mod, mod);
            localStorage.removeItem(mod);
            return true;
        } catch(e) {
            return false;
        }
    }

    var $window = $(window);

    $(document).ready(function()
    {
        /**
         * Auto save
         */
        $('.ce_form form').each(function()
        {
            // temporarily disabled
            //return false;

            // check for local storage
            if (!hasLocalStorage())
            {
                return false;
            }

            var $form = $(this);
            var formId = $form.attr('id');

            if (formId === undefined)
            {
                return true;
            }

            var cookieId = 'autosave-' + formId;

            var saveFormData = function()
            {
                var storageData = JSON.stringify({
                    expire: new Date().addHours(1),
                    data: $form.serializeArray()
                });

                localStorage.setItem(cookieId, storageData);

                return true;
            };

            var loadFormData = function()
            {
                var storageItem = localStorage.getItem(cookieId);

                if (null !== storageItem)
                {
                    storageItem = JSON.parse(storageItem);

                    if (new Date() < new Date(storageItem.expire))
                    {
                        return storageItem.data;
                    }
                }

                return undefined;
            };

            var eraseFormData = function()
            {
                localStorage.removeItem(cookieId);
                return true;
            };


            // load form data
            var previousFormData = loadFormData();
            if (previousFormData !== undefined)
            {
                $.each(previousFormData, function(index, item)
                {
                    $form.find('input, textarea, select').filter('[name="' + item.name + '"]').not('[type="hidden"]').each(function()
                    {
                        var $input = $(this);
                        var $radioCheckboxSelect = $input.filter('[type="radio"], [type="checkbox"], select');
                        var $textInput = $input.not('[type="radio"], [type="checkbox"], select');

                        // don't do anything if there is already a value on text input
                        if ($textInput.val())
                        {
                            return true;
                        }

                        if ($radioCheckboxSelect.length > 0)
                        {
                            if (item.value)
                            {
                                var $inputValue = $input.filter('[value="' + item.value + '"]');
                                if ($inputValue.length > 0)
                                {
                                    $inputValue.prop('checked', true).prop('selected', true).change();
                                    return false;
                                }

                                var $option = $input.find('[value="' + item.value + '"]');
                                if ($option.length > 0)
                                {
                                    $option.prop('checked', true).prop('selected', true).change();
                                    return false;
                                }

                                return true;
                            }
                        }
                        else
                        {
                            $input.val(item.value);
                            return false;
                        }
                    });
                });
            }


            // save form data
            var timeoutId;
            $form.find('input, textarea, select').on('change propertychange input', function()
            {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(saveFormData, 1000);
            });
        });


        /**
         * Auto grow text areas
         */
        function autoresize(textarea)
        {
            if ($(textarea).is(':visible'))
            {
                textarea.style.height = '0px';
                textarea.style.height = textarea.scrollHeight + 'px';
            }
        }
        $('textarea').each(function()
        {
            autoresize(this);
            $(this).keyup(function(event) {
                autoresize(this);
            });
        });


        /**
         * Focus of widgets
         */
        var moveLabel = function() {
            $('form .widget').each(function()
            {
                var $widget = $(this);
                $widget.find('input:not([type="checkbox"]):not([type="radio"]),select,textarea').each(function()
                {
                    var $input = $(this);
                    if ($input.val() != '' || $input.attr('placeholder'))
                    {
                        $widget.addClass('move-label');
                    }
                }).focus(function()
                {
                    $widget.addClass('move-label'); 
                }).focusout(function()
                {
                    var $input = $(this);
                    if ($input.val() == '' || $input.attr('placeholder'))
                    {
                        $widget.removeClass('move-label');
                    }
                });
            });
        };
        moveLabel();
        $(window).on('load', moveLabel);


        /**
         * Chosen class for radio and checkbox
         */
        $('form .widget-radio, form .widget-checkbox').each(function()
        {
            var $widget = $(this);
            var $inputs = $widget.find('input');
            var updateChosen = function()
            {
                if ($inputs.is(':checked'))
                {
                    $widget.addClass('chosen');
                }
                else
                {
                    $widget.removeClass('chose');
                }  
            }
            updateChosen();
            $inputs.on('change', updateChosen);
        });


        /**
         * Auto-check double password.
         */
        $('form').each(function(){
            $(this).find('.widget-password').not('.confirm').each(function(){
                var $pw1 = $(this);
                var $pw2 = $pw1.siblings('.widget-password.confirm');
                if ($pw2.length === 0) {
                    return true;
                }
                var $input1 = $pw1.find('input');
                var $input2 = $pw2.find('input');

                var validate = function() {
                    if ($input1.val() && $input2.val() && $input1.val() != $input2.val() && !$pw1.hasClass('error')) {
                        $pw1.addClass('error');
                        $pw2.addClass('error');
                        $input1.addClass('error');
                        $input2.addClass('error');
                        $('<p class="error">Die eingegebenen Passwörter stimmen nicht überein!</p>').insertAfter($pw1.find('label'));
                    }
                };

                var removeError = function() {
                    if ($input1.val() && $input2.val() && $input1.val() == $input2.val() && $pw1.hasClass('error')) {
                        $pw1.removeClass('error');
                        $pw2.removeClass('error');
                        $input1.removeClass('error');
                        $input2.removeClass('error');
                        $pw1.find('p.error').remove();
                    }
                };

                $input1.on('blur', validate);
                $input2.on('blur', validate);

                $input1.on('input', removeError);
                $input2.on('input', removeError);
            });
        });


        /**
         * Accordion style for password
         */
        $('.mod_personalData fieldset.aea804c7').each(function() {
            var $fieldset = $(this);
            var $container = $fieldset.find('.form-row-double__wrapper');
            var $legend = $fieldset.find('legend');

            $legend.click(function() {
                $legend.toggleClass('open');
                $container.slideToggle(200);
            });
        });
    });

})(jQuery);
